export default () => {
  const containers = document.querySelectorAll('.js-read-more')
  if (!containers) return
  
  ;[...containers].forEach((container) => {
    // console.log(container)
    const trigger = container.querySelector('.js-read-more-trigger')
    const panel = container.querySelector('.js-read-more-panel')
    const text = container.querySelector('.js-read-more-text')
    // console.log(trigger)
    const more = trigger.dataset.more
    const less = trigger.dataset.less
    

    if ( ! trigger || ! panel || ! text || ! more || ! less) return

    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      container.classList.toggle('active')
      trigger.classList.toggle('active')
      panel.classList.toggle('active')

      if (trigger.classList.contains('active')) {
        text.innerHTML = less
      } else {
        text.innerHTML = more
      }
    })
  })

}


// WEBPACK FOOTER //
// ./src/js/modules/ReadMore.js